import { render, staticRenderFns } from "./QuestionConfigurationModal.vue?vue&type=template&id=2aef5044&scoped=true"
import script from "./QuestionConfigurationModal.vue?vue&type=script&lang=js"
export * from "./QuestionConfigurationModal.vue?vue&type=script&lang=js"
import style0 from "./QuestionConfigurationModal.vue?vue&type=style&index=0&id=2aef5044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aef5044",
  null
  
)

export default component.exports